import http from './http';

export default {
  all() {
    return http().get(`/v1/contact_types`);
  },
  get(id) {
    return http().get(`/v1/contact_types/${id}`);
  },
  create(data) {
    return http().post(`/v1/contact_types`, data);
  },
  update(data) {
    return http().put(`/v1/contact_types/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/contact_types/${id}`);
  },
}
